import React from 'react'
import Wrapper from '../../components/layout/Wrapper'
import styled from 'styled-components'
import breakpoint from 'styled-components-breakpoint'
import imgCallCenter from '../../images/landing-contact-callcenter.svg'
import imgEmail from '../../images/landing-contact-email.svg'
import imgSucursales from '../../images/landing-contact-locations.svg'

const Container = styled(Wrapper)``

const ItemsGrid = styled.div`
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 40px;

  & > div {
    flex: 1 0 30%;
    margin-bottom: 20px;
    display: flex;
  }

  ${breakpoint('tablet')`
    flex-flow: row wrap;
    justify-content: space-between;
  `}
`

const ItemContainer = styled.div`
  display: flex;

  h4 {
    margin-top: 0;
    margin-bottom: 15px;
  }

  p {
    font-size: 12px;
    margin-right: 50px;
  }

  & > div {
    flex: 1 0;
  }

  & > div:first-of-type {
    flex: 0 0 60px;

    ${breakpoint('tablet')`
      margin-right: 20px;
      flex: 0 0 80px;
    `}
  }
`

const Disclaimer = styled.div`
  background: #f1f1f1;
  margin: 20px 0 0;
  padding: 20px 0 40px;

  h4 {
    margin-bottom: 0;
    font-size: 12px;
  }
  p {
    font-size: 11px;
  }
`

const Item = ({ title, image, children }) => {
  return (
    <ItemContainer>
      <div>
        <img src={image} alt={title} />
      </div>
      <div>
        <h4>{title}</h4>
        <p>{children}</p>
      </div>
    </ItemContainer>
  )
}

export default ({ footer, countryAbr }) => {
  const TituloCondiciones = footer
    ? footer.find(f => f.type === 'Titulo Condiciones')
    : null
  const TextoCondiciones = footer
    ? footer.find(f => f.type === 'Texto Condiciones')
    : null
  const Email = footer ? footer.find(f => f.type === 'Email') : null
  const Telefono = footer ? footer.find(f => f.type === 'Telefono') : null

  return (
    <div>
      <Container>
        <ItemsGrid>
          <Item title="Call Center" image={imgCallCenter}>
            Consultas sobre tu solicitud de tarjetas de crédito{' '}
            {Telefono && Telefono.texto.texto}
          </Item>

          <Item title="Email" image={imgEmail}>
            Consultas sobre tu solicitud de tarjetas de crédito{' '}
            {Email && Email.texto.texto}
          </Item>

          <Item title="Sucursales" image={imgSucursales}>
            <a
              href={`https://www.bacubicanos.com/responsive/index.aspx?pCountry=${countryAbr}&pChannel=BACNET`}
            >
              {
                // TODO replace this with a helper method
              }
              {['CRI', 'NIC'].includes(countryAbr) ? 'Hacé' : 'Haz'} clic aquí
            </a>{' '}
            para ver nuestros puntos de servicio.
          </Item>
        </ItemsGrid>
      </Container>
      <Disclaimer>
        <Container>
          <h4>*Imágenes:</h4>
          <p>
            Las imágenes de las tarjetas utilizadas exclusivamente con fines
            ilustrativos.
          </p>
          <h4>**Trámite de crédito:</h4>
          <p>
            Trámite de crédito quedará sujeto a las políticas de crédito de BAC
            Credomatic.
          </p>

          {TituloCondiciones && <h4>{TituloCondiciones.texto.texto}</h4>}
          {TextoCondiciones && <p>{TextoCondiciones.texto.texto}</p>}
          <p>Parque Empresarial del  Este  Edificio B10, San José, Goicochea 10201, Costa Rica.</p>
        </Container>
      </Disclaimer>
    </div>
  )
}
